import React from 'react'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import MuiRating from '@mui/material/Rating'
import Typography from '@mui/material/Typography'

interface RatingProps {
  disabled?: boolean
  value: number
  label: string
  options: Array<{ id: number; value: number; label: string }>
  onChange: (newValue: number) => void
}

// the rating component handles values from 0 to x. We need to convert to our own scale, for example to use values 6-10
const Rating = (props: RatingProps): JSX.Element => {
  const [hoverRating, setHoverRating] = React.useState<number>(-1)

  return (
    <FormControl sx={{ mb: 3, mr: 3 }}>
      <FormLabel>{props.label}</FormLabel>
      <MuiRating
        sx={{
          color: 'primary.main',
          fontSize: { xs: '4rem', md: '2.65rem' },
        }}
        onChange={(_event, newValue: number | null) => {
          if (newValue) {
            const ratingValue = props.options[newValue - 1].value
            setHoverRating(-1)
            props.onChange(ratingValue)
          }
        }}
        onChangeActive={(_event, newHover: number) => {
          const ratingValue = newHover > 0 ? props.options[newHover - 1].value : -1
          setHoverRating(ratingValue)
        }}
        max={props.options.length}
        value={props.options.findIndex((x) => x.value === props.value) + 1}
        disabled={props.disabled}
      />
      <Typography sx={{ whiteSpace: 'pre' }}>
        {props.options.find((x) => {
          const findValue = hoverRating > -1 ? hoverRating : props.value
          return x.value === findValue
        })?.label || ' '}
      </Typography>
    </FormControl>
  )
}

export default Rating
